import React, { Fragment } from 'react';
import { GIFT_CARD_SVG } from '../../staticTypes'

const StReferral = () => {
	return (
		<Fragment>
			<div className="referrals-explainer-card">
				<div className="heading mb-5 pt-2 text-center">Referrals</div>
				<div className="card-description text-center">
					Give your friends a reward and claim your own when they make a
														purchase.
														</div>
				<div className="card-list-container">
					<div className="card-list-item no-hover">
						<div className="card-list-item-content">
							{GIFT_CARD_SVG}
							<div className="list-item-text-wrapper">
								<div className="list-item-title">They get</div>
								<div className="list-item-subtitle text-muted">$15 off coupon</div>
							</div>
						</div>
					</div>
					<div className="card-list-item no-hover">
						<div className="card-list-item-content">
							{GIFT_CARD_SVG}
							<div className="list-item-text-wrapper">
								<div className="list-item-title">You get</div>
								<div className="list-item-subtitle text-muted">$15 off coupon</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Fragment>
	);
}

export default StReferral;